import { Sparkles } from "lucide-react";

/**
 * "Beta Vendor" badge shown on profile, storefront, and map pin popup for
 * users who claimed one of the 50 founding beta spots.
 * Rendered only when `is_beta_tester === true`.
 */
export default function BetaVendorBadge({ className = "", size = "sm", program = null }) {
  const px = size === "xs" ? "px-1.5 py-0" : "px-2 py-0.5";
  const text = size === "xs" ? "text-[9px]" : "text-[10px]";
  const iconSize = size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3";
  const label =
    program === "farm_stand"
      ? "Beta Farm Stand"
      : program === "cake_pop"
      ? "Beta Cake Pop"
      : "Beta Vendor";
  return (
    <span
      title="Founding beta vendor — one of the first 50"
      className={`inline-flex items-center gap-1 rounded-full ${px} ${text} font-semibold uppercase tracking-wide bg-[#FFD07F]/70 text-[#B26A00] border border-[#F4A83B]/40 ${className}`}
      data-testid="beta-vendor-badge"
    >
      <Sparkles className={iconSize} /> {label}
    </span>
  );
}
